import React, { useEffect, useState, useRef, useMemo, useContext } from "react";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import moment from "moment";
import { AppContext } from "../../../context/AppContext";
import CommonTabular from "../../../components/Datatable/CommonTabular";

const EmployeeContactList = (props) => {
  const token = localStorage.getItem("Token");
  const locationid = localStorage.getItem("Location");
  const { CurrencySymbol, FractionDigits, dateFormate, ReportViewPermission } =
    useContext(AppContext);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [classicView, setClassicView] = useState(true);

  // const columns = useMemo(() => [
  //   {
  //     header: "ID",
  //     accessorKey: "ID",
  //     filterFn: "contains",
  //     size: "110",
  //   },
  //   {
  //     header: "Employee",
  //     accessorKey: "Employee",
  //     filterFn: "contains",
  //     size: "110",
  //   },
  //   {
  //     header: "Phone Number",
  //     accessorKey: "PhoneNumber",
  //     filterFn: "contains",
  //     size: "110",
  //   },
  //   {
  //     header: "Email",
  //     accessorKey: "Email",
  //     filterFn: "contains",
  //     size: "110",
  //   },
  //   {
  //     header: "Address",
  //     accessorKey: "Address",
  //     filterFn: "contains",
  //     size: "110",
  //   },
  //   {
  //     header: "City",
  //     accessorKey: "City",
  //     filterFn: "contains",
  //     size: "110",
  //   },
  //   {
  //     header: "State",
  //     accessorKey: "State",
  //     filterFn: "contains",
  //     size: "110",
  //   },
  //   {
  //     header: "Zip",
  //     accessorKey: "Zip",
  //     filterFn: "contains",
  //     size: "110",
  //   },
  //   {
  //     header: "Country",
  //     accessorKey: "Country",
  //     filterFn: "contains",
  //     size: "110",
  //   },
  //   {
  //     header: "Joining Date",
  //     accessorKey: "HireDate",
  //     Cell: ({ row }) => {
  //       if (row?.original?.HireDate != "") {
  //         return moment(row.original.HireDate).format("MM/DD/YYYY");
  //       }
  //     },
  //     filterFn: "contains",
  //     size: "110",
  //   },
  //   {
  //     header: "Is Deleted",
  //     accessorKey: "Deleted",
  //     filterFn: "contains",
  //     size: "110",
  //   },
  // ]);


  const Classiccolumns = [
    {
      title: "Employee",
      field: "Employee",
      headerFilter: "input",
      frozen: true,
      defaultVisible: true,
    },
    {
      title: "PhoneNumber",
      field: "PhoneNumber",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Email",
      field: "Email",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Address",
      field: "Address",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "City",
      field: "City",
      headerFilter: "input",
      // defaultVisible: true,
    },
    {
      title: "Created By",
      field: "CreatedBy",
      headerFilter: "input",
      // defaultVisible: true,
    },
    {
      title: "Created Date",
      field: "CreatedDate",
      headerFilter: "input",
      // defaultVisible: true,
      formatter: function (cell) {
        const value = cell.getValue();
        const dateFormatString = `${dateFormate.toUpperCase()} h:mm A`;

        const formattedDate = moment(value).isValid()
          ? moment(value).format(dateFormatString)
          : "";

        return formattedDate;
      },
    },
    {
      title: "Deleted",
      field: "Deleted",
      headerFilter: "input",
      // defaultVisible: true,
    },
    {
      title: "Hire Date",
      field: "HireDate",
      headerFilter: "input",
      // defaultVisible: true,
    },
    {
      title: "Modified By",
      field: "ModifiedBy",
      headerFilter: "input",
    },
    {
      title: "Modified Date",
      field: "ModifiedDate",
      headerFilter: "input",
      formatter: function (cell) {
        const value = cell.getValue();
        const dateFormatString = `${dateFormate.toUpperCase()} h:mm A`;

        const formattedDate = moment(value).isValid()
          ? moment(value).format(dateFormatString)
          : "";

        return formattedDate;
      },
    },
  ];

  const columns = useMemo(() => [
    {
      header: "Employee",
      accessorKey: "Employee",
    },
    {
      header: "Phone",
      accessorKey: "PhoneNumber",
    },
    {
      header: "Email",
      accessorKey: "Email",
    },
    {
      header: "Address",
      accessorKey: "Address",
      Cell: ({ row }) => {
        return [
          row?.original?.Address1,
          row?.original?.Address2,
          row?.original?.City,
          row?.original?.State + " " + row?.original?.Zip,
          row?.original?.Country,
        ]
          .filter(Boolean)
          .join(", ");
      },
    },
    {
      header: "City",
      accessorKey: "City",
    },
    {
      header: "Country",
      accessorKey: "Country",
    },
    {
      header: "Created By",
      accessorKey: "CreatedBy",
    },
    {
      header: "Created date",
      accessorKey: "CreatedDate",
      Cell: ({ row }) =>
        moment(row.original.CreatedDate).format(
          `${dateFormate.toUpperCase()} hh:mm A`
        ),
    },
    {
      header: "Deleted",
      accessorKey: "Deleted",
    },
    {
      header: "Employee no",
      accessorKey: "Employeenumber",
    },
    // {
    //   header: "Gender",
    //   accessorKey: "Gender",
    // },
    {
      header: "Hire date",
      accessorKey: "HireDate",
      Cell: ({ row }) => {
        const lastModifiedDate = row.original.HireDate;
        return lastModifiedDate === ""
          ? ""
          : moment(lastModifiedDate).format(`${dateFormate.toUpperCase()}`);
      },
    },
    {
      header: "Last modified by",
      accessorKey: "ModifiedBy",
    },
    {
      header: "Last modified date",
      accessorKey: "ModifiedDate",
      Cell: ({ row }) => {
        const lastModifiedDate = row.original.ModifiedDate;
        return lastModifiedDate === ""
          ? ""
          : moment(lastModifiedDate).format(
              `${dateFormate.toUpperCase()} hh:mm A`
            );
      },
    },
    // {
    //   header: "Mobile",
    //   accessorKey: "Mobile",
    // },
    // {
    //   header: "Note",
    //   accessorKey: "Note",
    // },
    // {
    //   header: "Phone",
    //   accessorKey: "Phone",
    // },
    {
      header: "State",
      accessorKey: "State",
    },
    {
      header: "Zip code",
      accessorKey: "Zip",
    },
  ]);
  const apicall = () => {
    setLoading(true);
    axios
      .get(
        `${config.reportsBaseUrl}/reports/employeecontactlist?filtercolumnsearchtext=&currentorder=&ordercolumn=&pagesize=&pagenumber=&filtertext=&locationid=${locationid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res);
        console.log(res.data.ResponseData);
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(res.data.ResponseData);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const onRefreshClick = () => {
    apicall();
  };

  useEffect(() => {
    apicall();
  }, []);

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Employee Contact List
                </li>
              </ul>
            </div>
          </div>
          <div className="card mt-3" id="print">
            <div className="card-body">
              <div className="container">
                <div className="col-md-12 text-center" id="header">
                  <h6 className="p">SonarPos</h6>
                  <p className="fw-bold p-regular">Employee Contact List</p>
                </div>
                <button
                  className="btn btn-sm mt-3"
                  style={{ alignSelf: "self-end" }}
                  onClick={() => onRefreshClick()}
                >
                  <i class="fa fa-refresh me-2"></i>
                  Refresh
                </button>
              </div>

              <hr />
              <div className="table-responsive">
                {ReportViewPermission == true ? (
                  <button
                    className="btn btn-secondary"
                    onClick={() => setClassicView(!classicView)}
                  >
                    {" "}
                    {classicView ? "ClassicView" : "Morden View"}
                  </button>
                ) : (
                  <></>
                )}
                {classicView ? (
                  <CommonTabular
                    Data={responseData}
                    columns={Classiccolumns}
                    Groupvalue={[]}
                    Reportname={"Employee_Contact_List"}
                    frozenRowvalue={0}
                    // layout={"fitDataFill"}
                    Onrefresh={() => apicall()}
                  />
                ) : (
                  <CommonMatrialReactTable
                    MainHeading="Sonar POS"
                    ReportHeading="Employee Contact List"
                    columns={columns}
                    data={responseData}
                    startdate={startdate}
                    enddate={enddate}
                    columnGrouping={[]}
                    columnsVisibility={{
                      City: false,
                      Country: false,
                      CreatedBy: false,
                      CreatedDate: false,
                      Deleted: false,
                      Employeenumber: false,
                      HireDate: false,
                      ModifiedBy: false,
                      ModifiedDate: false,
                      State: false,
                      Zip: false,
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeeContactList;
